export default {
  env: "staging",
  mcpUrl: "https://mcp.cb.c7m.io",
} as const;
